/* -------------------------------------------------------------------------- */
/* Filters MIXIN                                                                */
/* -------------------------------------------------------------------------- */
import {
    Component, Mixins,
} from 'vue-property-decorator';
import { digits } from '@groot-nodes/helpers/number';

/**
 * Forms Mixin
 */
@Component
class FiltersMixin extends Mixins() {
    digits = digits;
}

export default FiltersMixin;
